import { Box, Typography, styled } from '@mui/material';

export type EventSeverity = 'critical' | 'important' | 'common';

export const EventBanner = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'severity',
})<{ severity: EventSeverity }>(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  alignSelf: 'stretch',
  justifySelf: 'stretch',
  cursor: 'pointer',
  transition: 'opacity 0.2s',
  '&:hover': {
    opacity: 0.8,
  },
}));

export const IconCircle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  padding: '3px',
  borderRadius: '36px',
  background: color || 'transparent',
  width: '20px',
  height: '20px',
  aspectRatio: '1/1',
}));

export const EventTextWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '5px',
}));

export const EventText = styled(Typography)(() => ({
  color: 'var(--Typography-p-primary, #615E6F)',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  whiteSpace: 'nowrap',
}));
